var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#F7FEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3047 14.8201C26.281 13.8438 26.281 12.2609 25.3047 11.2846L24.7155 10.6953C23.7391 9.71902 22.1562 9.71902 21.1799 10.6953L11.691 20.1843C11.3462 20.529 11.1098 20.967 11.0108 21.4444L10.3411 24.6737C10.2193 25.2609 10.7391 25.7807 11.3263 25.6589L14.5556 24.9892C15.033 24.8902 15.471 24.6538 15.8158 24.3091L25.3047 14.8201ZM24.1262 12.4631L23.5369 11.8738C23.2115 11.5484 22.6839 11.5484 22.3584 11.8738L21.4745 12.7578L23.2423 14.5255L24.1262 13.6416C24.4516 13.3162 24.4516 12.7885 24.1262 12.4631ZM22.0638 15.704L20.296 13.9363L12.8695 21.3628C12.7546 21.4777 12.6758 21.6237 12.6428 21.7828L12.2308 23.7692L14.2172 23.3573C14.3763 23.3243 14.5223 23.2455 14.6373 23.1305L22.0638 15.704Z",
    fill: "#F7FEFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePhoto);
export default __webpack_public_path__ + "static/media/change-photo.75bae467ce8141d4d649814552a86e47.svg";
export { ForwardRef as ReactComponent };